"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const validation_1 = require("../../validation");
const ItemDefinition_1 = require("./ItemDefinition");
const zod_1 = require("zod");
const configSchema = zod_1.z.object({
    videoUrl: zod_1.z.string((0, validation_1.labelZodErrors)("Video URL")).url("Video URL is required."),
});
const dataSchema = zod_1.z.object({
    playedAtLeastOnce: zod_1.z.boolean((0, validation_1.customZodError)("Video must be played.")),
});
exports.default = new ItemDefinition_1.ItemDefinition("Video", configSchema, dataSchema, new validation_1.ValidatorPipeline("Video Config Validator", []), new validation_1.ValidatorPipeline("Video Data Validator", [
    (0, validation_1.createZodSchemaValidator)(["data", "playedAtLeastOnce"], zod_1.z.literal(true, (0, validation_1.customZodError)("Video must be played."))),
]));
//# sourceMappingURL=Video.js.map